import { Checkbox, ListItemText, MenuItem } from '@material-ui/core'
import { FieldInputProps } from 'react-final-form'
import { SelectType } from '../../../../Types'

/**
 * @description render an array of react element
 * @param options
 */
export const renderOptions = (
  input: FieldInputProps<string, HTMLElement>,
  options: SelectType[] | undefined
): React.ReactNode => {
  if (options) {
    return options.map((select) => (
      <MenuItem key={select.value} value={select.value}>
        <Checkbox checked={input.value.indexOf(select.value as string) > -1} />
        <ListItemText primary={select.label} />
      </MenuItem>
    ))
  }
  return <div />
}
